<template>
  <v-list class="list" dense>
    <v-list-item v-for="(item, i) in list" :key="i" dense>
      <v-list-item-icon class="list-icon" v-if="putIcon">
        <Icon
          type="check-circle"
          theme="twoTone"
          :two-tone-color="variant_color ? 'light_purple' : 'blue'"
        />
      </v-list-item-icon>
      <v-list-item-content class="list-item-content">
        <CText :text="item" :color_text="'dark_grey'" :justify="false" />
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import CText from "./Text";
import { Icon } from "ant-design-vue";

export default {
  name: "CList",
  components: { CText, Icon },
  props: {
    list: {
      type: Array,
      default: null
    },
    color: {
      type: String,
      default: () => "blue"
    },
    variant_color: {
      type: Boolean,
      default: false
    },
    putIcon: {
      type: Boolean,
      default: true
    }
  },
  mounted() {}
};
</script>

<style scoped>
.list {
  background-color: transparent !important;
}
.list-icon {
  margin-right: 10px !important;
}
.list-item-content {
  padding: 0px;
}
.v-list--dense .v-list-item,
.v-list-item--dense {
  min-height: 20px;
}
</style>
